import { Link, Text } from '@afterpaytouch/core'
import { Trans, useTranslation } from '../../../utils/convergence'
import React, { FunctionComponent } from 'react'
import { TrackingEvent } from '../../../model/monitoring'
import { useIsPartialVerified } from '../../../state'
import { useCheckoutSizes } from '../../../utils/responsive'
import { useIsRetryPageContext } from '../helper'
import { useMonitoringWithEnduringEventProperties } from '../../../integrations/monitoring'

export const HardIdHelpLink: FunctionComponent = () => {
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()
  const isRetryPage = useIsRetryPageContext()
  const isRetryMode = useIsPartialVerified() && isRetryPage
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  if (!isRetryMode) {
    return null
  }

  return (
    <Text size={textSize}>
      <Trans
        i18nKey='verifyIdentity:partialVerified:help'
        components={{
          a: (
            <Link
              key='description-link'
              onClick={() => logEvent(TrackingEvent.PRESSED_HARDID_RETRY_PAGE_HELP_LINK)}
              target='_blank'
              kind='Underline'
              href={t('common:identityHelpUrl')}
              testNameSpace='verifyIdentity'
            />
          ),
        }}
      />
    </Text>
  )
}
